import React, { useState, useEffect, useRef } from "react";
import { sendTestMatomoEvent } from "../../Analytics/MatomoManager/matomoTest";
import { Translate } from "../LanguageChanger";

const VideoSettingPage = ({
  currentBitrate,
  onBitrateChange,
  mpdXMLInfo,
  handleQualityControl,
  handleSpeedControl,
  player,
  isLiveContent,
  currentSpeed,
  currentQuality,
   itemData,
  CurrentItemData,
}) => {
  // const tracks = player.getVariantTracks();
  const tracks = player?.getVariantTracks() || [];
  // const eventTracks = player.getTextTracks();
  const uniqueTracks = tracks.filter(
    (track, index, self) =>
      index === self.findIndex((t) => t.height === track.height)
  );
  // const uniqueTracks = null;
  console.log("tracks...", tracks, uniqueTracks);
  const autoOption = { id: "auto", height: "Auto" };
  const qualityOptionsWithAuto = [autoOption, ...uniqueTracks];
  const uniqueQuality = new Set();
  const uniqueQualityData = [];
  qualityOptionsWithAuto.forEach((quality) => {
    if (quality.height && !uniqueQuality.has(quality.height)) {
      uniqueQuality.add(`${quality.height}p`);
      uniqueQualityData.push(
        quality.height == "Auto" ? `${quality.height}` : `${quality.height}p`
      );
    }
  });

  const [activeTab, setActiveTab] = useState("quality");
   const [selectedQuality, setSelectedQuality] = useState(
    currentQuality || uniqueQualityData[0]
  );
  const [ActiveQuality, setActiveQuality] = useState(selectedQuality);
  const [ActiveSpeed, setActiveSpeed] = useState(`${currentSpeed}x`);
  const [selectedSpeed, setSelectedSpeed] = useState(`${currentSpeed}x`);
  const qualityRefs = useRef([]);
  const speedRefs = useRef([]);
  const [selectedBitrate, setSelectedBitrate] = useState("");
  const speedLabel = ["0.5x", "0.75x", "1x", "1.25x", "1.5x", "2x"];
  var qualityLabel = uniqueQualityData;
  
  // Add mounted ref to prevent state updates after unmount
  const isMountedRef = useRef(true);


const handleQualityChange = (quality) => {
    if (!isMountedRef.current) return;
    
    setActiveQuality(quality);
    setSelectedQuality(quality);

    if (player) {
      if (quality === "auto") {
        // Enable Shaka Player's automatic quality selection
        player.configure({ abr: { enabled: true } });
      } else {
        // Convert "720p" to a numeric value (720)
        const numericQuality = parseInt(quality.replace("p", ""), 10);
        const tracks = player.getVariantTracks();
        const selectedTrack = tracks.find(
          (track) => track.height === numericQuality
        );

        if (selectedTrack) {
          // Disable automatic quality selection and switch to manual
          player.configure({ abr: { enabled: false } });
          player.selectVariantTrack(selectedTrack, /* clearBuffer= */ true);
          console.log(`Switched to quality: ${numericQuality}p`);
        } else {
          console.log(`Quality ${numericQuality}p not available`);
        }
      }
    }
  // Send Event
const numericQuality = quality === "auto" ? "auto" : quality;
  sendMatomoEvent({ type: "Quality", value: numericQuality });
  };


  
  const handleSpeedChange = (speed) => {
    if (!isMountedRef.current) return;
    
    setActiveSpeed(speed);
    setSelectedSpeed(speed);
 // Send Event
    sendMatomoEvent({ type: "Speed", value: speed });
  };


  const sendMatomoEvent = ({ type, value }) => {
  const videoType = itemData?.[0]?.category_title;
  const { id: itemId, title: itemTitle } = itemData[0];
  const currentTitle =
    CurrentItemData?.title ?? itemData?.[0]?.season?.[0]?.title ?? "";
  const currentSeason = itemData?.[0]?.season?.[0];
  const currentSeasonNumber = currentSeason?.number;
  const episodeNumber = currentTitle.match(/\d+/g)?.[0] ?? "1";
  const isLiveChannel = itemData?.[0]?.still_live === 1;

  console.log("videoType22", isLiveChannel,itemData);

  const contentType = isLiveChannel ? "LiveChannel" : "Video";

  let eventCategory = "SelectSettingPopup";
  let eventAction = "Select";
  let eventName = "";

  switch (videoType) {
    case "TV Channels":
    case "Live":
      eventName = `${contentType}/${itemId}/${itemTitle}/${type}(${value})`;
      break;

    case "Shows":
      eventName = `${contentType}/${itemId}/${itemTitle}-S${currentSeasonNumber} E${episodeNumber} ${currentTitle}/${type}(${value})`;
      break;

    case "Movies":
      eventName = `${contentType}/${itemId}/${itemTitle}-${itemTitle}/${type}(${value})`;
      break;

    case "Shorts":
      eventCategory = "Video";
      eventName = `${contentType}/${itemId}/${itemTitle}-${itemTitle}/${type}(${value})`;
      break;  

    default:
      return; // unknown type
  }

  sendTestMatomoEvent({ eventCategory, eventAction, eventName });
};



  useEffect(() => {
    let timeoutId;
    
    if (activeTab === "quality") {
      // Jo currently selected hai uska index dhundo
      const index = qualityLabel.indexOf(selectedQuality);
      const focusIndex = index !== -1 ? index : 0;
      
      timeoutId = setTimeout(() => {
        if (isMountedRef.current && qualityRefs.current[focusIndex]) {
          qualityRefs.current[focusIndex].focus();
        }
      }, 50);
    } else if (activeTab === "speed") {
      const index = speedLabel.indexOf(selectedSpeed);
      const focusIndex = index !== -1 ? index : 0;
      
      timeoutId = setTimeout(() => {
        if (isMountedRef.current && speedRefs.current[focusIndex]) {
          speedRefs.current[focusIndex].focus();
        }
      }, 50);
    }
    
    // Cleanup timeout on unmount or when dependencies change
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [activeTab]);

    useEffect(() => {
    sendTestMatomoEvent({
      eventCategory: `(VideoPlayer)`,
      eventAction: `View`,
      eventName: `SelectSettingPopup`,
    });
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleTabChange = (tab) => {
    if (!isMountedRef.current) return;
    setActiveTab(tab);
  };

  const handleQualitySelect = (quality) => {
    if (!isMountedRef.current) return;
    setSelectedQuality(quality);
  };

  const handleSpeedSelect = (speed) => {
    if (!isMountedRef.current) return;
    setSelectedSpeed(speed);
    onBitrateChange(speed);
  };

  const handleKeyDown = (e, index, type) => {
    if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
      e.preventDefault();
    }
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
 
      if (type === "quality") {
        handleQualityControl(qualityLabel[index]);
        handleQualityChange(qualityLabel[index]);
      } else if (type === "speed") {
        handleSpeedControl(speedLabel[index].replace("x", ""));
        handleSpeedChange(speedLabel[index]);
      }
    }
    else if (type === "quality") {
      if (e.key === "ArrowDown" && index < qualityRefs.current.length - 1) {
        setSelectedQuality(qualityLabel[index + 1]);
        qualityRefs.current[index + 1]?.focus();
      } else if (e.key === "ArrowUp") {
        if (index > 0) {
          setSelectedQuality(qualityLabel[index - 1]);
          qualityRefs.current[index - 1]?.focus();
        }
      } else if (e.key === "ArrowRight" && !isLiveContent) {
        setActiveTab("speed");
      }
    } else if (type === "speed") {
      if (e.key === "ArrowDown" && index < speedRefs.current.length - 1) {
        setSelectedSpeed(speedLabel[index + 1]);
        speedRefs.current[index + 1]?.focus();
      } else if (e.key === "ArrowUp") {
        if (index > 0) {
          setSelectedSpeed(speedLabel[index - 1]);
          speedRefs.current[index - 1]?.focus();
        }
      } else if (e.key === "ArrowLeft") {
        setActiveTab("quality");
      }
    }
  };

useEffect(() => {
    if (currentSpeed) {
      const formattedSpeed = `${currentSpeed}x`;
      setActiveSpeed(formattedSpeed);
      setSelectedSpeed(formattedSpeed);
    }
  }, [currentSpeed]);

  const handleBitrateChange = (bitrate) => {
    if (!isMountedRef.current) return;
    setSelectedBitrate(bitrate);
    onBitrateChange(bitrate); // Call parent component's method to change bitrate
  };

  return (
    <div style={styles.settingsMenu} className="settings-container">
      {/* <div style={styles.tabs}>
        <button
          style={{
            ...styles.settingsMenuTab,
            ...(activeTab === 'quality' ? styles.activeTabs : {})
          }}
          onClick={() => handleTabChange('quality')}
        >
          Settings
        </button>
      </div> */}
      <h4 style={{ fontSize: "18px", fontWeight: "600" }}><Translate langKey={"settings"}/></h4>
      <div style={styles.tabs}>
        {/* <button
          style={{
            ...styles.tabButton,
            width: isLiveContent ? '100%': '50%',
            ...(activeTab === 'quality' ? styles.activeTab : {})
          }}
          onClick={() => handleTabChange('quality')}
        >
          Quality
        </button> */}
        <button
          style={{
            ...styles.tabButton,
            width: isLiveContent ? "100%" : "50%",
            ...(activeTab === "quality" && styles.activeTab), // Avoid unnecessary spread operator
          }}
          onClick={() => handleTabChange("quality")}
        >
          <Translate langKey={"video_quality"}/>
        </button>
        {!isLiveContent && (
          <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "speed" ? styles.activeTab : {}),
            }}
            onClick={() => handleTabChange("speed")}
          >
             <Translate langKey={"video_speed"}/>
          </button>
        )}
      </div>

      {activeTab === "quality" && (
        <div style={styles.qualityOptions}>
          {qualityLabel.map((quality, index) => (
            <div
              key={quality}
              tabIndex={0}
              ref={(el) => (qualityRefs.current[index] = el)}
              style={{
                ...styles.qualityOption,
                ...(selectedQuality === quality ? styles.selectedOption : {}),
              }}
              onClick={() => {
                handleQualityControl(quality); // Menu Band + Action
                handleQualityChange(quality); // UI Update
              }}
              onKeyDown={(e) => handleKeyDown(e, index, "quality")}
            >
              {quality}
              {ActiveQuality === quality && (
                <span style={styles.checkmark}>✔</span>
              )}
            </div>
          ))}
        </div>
      )}

      {activeTab === "speed" && !isLiveContent && (
        <div style={styles.speedOptions}>
          {speedLabel.map((speed, index) => (
            <div
              key={speed}
              tabIndex={0}
              ref={(el) => (speedRefs.current[index] = el)}
              style={{
                ...styles.qualityOption,
                ...(selectedSpeed === speed ? styles.selectedOption : {}),
              }}
              onClick={() => {
                setSelectedSpeed(speed);
                onBitrateChange(speed);
                setActiveSpeed(speed);
                handleSpeedControl(speed.replace("x", ""));
              }}
              onKeyDown={(e) => handleKeyDown(e, index, "speed")}
            >
              {speed}
              {ActiveSpeed === speed && <span style={styles.checkmark}>✔</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  settingsMenu: {
    backgroundColor: "rgb(0, 0, 0)",
    opacity: "0.8",
    color: "rgb(255, 255, 255)",
    padding: "20px",
    width: "300px",
    borderRadius: "8px",
    fontFamily: "Anek Latin",
    float: "right",
    position: "absolute",
    right: "0px",
    height: "95vh",
  },
  tabs: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  tabButton: {
    backgroundColor: "rgb(31, 31, 31)",
    color: "white",
    border: "none",
    padding: "10px 20px",
    cursor: "pointer",
    fontSize: "16px",
    borderRadius: "5px",
    width: "50%", // Ensure equal width for both tabs
  },
  settingsMenuTab: {
    backgroundColor: "rgb(31, 31, 31)",
    color: "white",
    border: "none",
    padding: "10px 20px",
    cursor: "pointer",
    fontSize: "16px",
    borderRadius: "5px",
    width: "100%", // Ensure equal width for both tabs
    textAlign: "left",
  },
  activeTab: {
    backgroundColor: "#EC008C",
    color: "white",
  },
  activeTabs: {
    textAlign: "left",
  },
  qualityOptions: {
    display: "flex",
    flexDirection: "column",
  },
  qualityOption: {
    backgroundColor: " rgb(31, 31, 31)",
    padding: "10px 20px",
    margin: "5px 0",
    borderRadius: "5px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "16px",
    outline: "none", // Remove the default outline when focused
  },
  selectedOption: {
    backgroundColor: " #EC008C",
  },
  checkmark: {
    fontSize: "18px",
  },
  speedOptions: {
    display: "flex",
    flexDirection: "column",
  },
};

export default VideoSettingPage;
